import React from "react";
import { Pagination, PaginationItem } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

const MuiPagination = ({ page, limit, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / limit);

  if (totalPages <= 1) return null; // Hide pagination if only one page

  return (
    <Pagination
      count={totalPages}
      page={page}
      onChange={(event, newPage) => onPageChange(newPage)}
      color="primary"
      size="medium"
      shape="rounded"
      showFirstButton
      showLastButton
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 2,
      }}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          sx={{
            "&.Mui-selected": {
              backgroundColor: "primary.main",
              color: "white",
              fontWeight: "bold",
            },
          }}
          slots={{
            previous: ArrowBack,
            next: ArrowForward,
          }}
        />
      )}
    />
  );
};

export default MuiPagination;
